<template>
  <b-row class="justify-content-between mt-2">
    <b-col cols="2">
      <div class="buttom-container">
        <div class="d-flex justify-content-between">
          <a class="input-header-txt">Print Comments</a>
        </div>
        <lookup-dropdown
          :options="printComments"
          moduleName="printComments"
          propKey="name"
          resource="PrintComments"
          lookupId="19"
          class="mb-2"
          @change="onPrintCommentChange"
        />
        <b-textarea rows="5" v-model.trim="vendorrma.comments" />
      </div>
      <div class="buttom-container mt-2">
        <b-form-group label="Internal Comments">
          <b-textarea rows="5" v-model="vendorrma.internalComments" />
        </b-form-group>
      </div>
    </b-col>
    <b-col cols="3">
    </b-col>
    <b-col cols="5">
      <b-tabs>
        <b-tab title="Return Summary" active>
          <quote-summary v-bind:quote="vendorrma" />
        </b-tab>
        <b-tab title="Charges">
          <charges-list :vendorRmaId="vendorRmaId" @updateCharge="$emit('onRefresh')" />
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>

<script>

import debounce from 'lodash/debounce';
import { mapActions, mapGetters } from 'vuex';
import ChargesList from '@/shared/components/ChargesList/index';
import QuoteSummary from '@/pages/Quotes/components/EditQuote/components/QuoteSummary';
const DEBOUNCE_TIME = 750;

export default {
  computed: {
    ...mapGetters('lookup', ['currencies','printComments']),
    ...mapGetters('vendorrmas', ['vendorrma']),
    vendorRmaId() {
      return this.$route.params.id;
    },
  },
  components: {
    ChargesList,
    QuoteSummary
  },
  methods: {
    /*formatNumber(value, event) {
      return Number(value).toLocaleString();
    },
    updateTotal(emit) {
      if (emit) {
        this.vendorrma.total = Number(emit.total).toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 2 });
        this.vendorrma.subTotal = Number(emit.subTotal).toLocaleString();
        this.vendorrma.totalCharges = Number(emit.charges).toLocaleString();
      }
    },*/
    onPrintCommentChange({text,name}) {
      this.vendorrma.comments = text || name;
    },
  },

};
</script>
